import { AffiliateTagApi } from '@api';
import {
  mediaCategoryTypes as actionTypes,
  marketplaceMediaCategoryTypes as marketplaceActionTypes,
} from './types';

export const fetchMediaCategories = (locale) => (dispatch) => {
  dispatch({
    type: actionTypes.LOADING,
  });

  AffiliateTagApi.getGroupedMediaCategories({ locale })
    .then((response) => {
      dispatch({
        type: actionTypes.SUCCESS,
        payload: { [locale]: response },
      });
    })
    .catch((error) => {
      dispatch({
        type: actionTypes.FAILURE,
        message: `notify:general.errors.${error.status}`,
      });
    });
};

export const fetchMarketplaceMediaCategories = (locale, params) => (dispatch) => {
  dispatch({
    type: marketplaceActionTypes.LOADING,
  });

  AffiliateTagApi.getGroupedMediaCategories({ locale, marketplace: true, ...params })
    .then((response) => {
      dispatch({
        type: marketplaceActionTypes.SUCCESS,
        payload: { [locale]: response },
      });
    })
    .catch((error) => {
      dispatch({
        type: marketplaceActionTypes.FAILURE,
        message: `notify:general.errors.${error.status}`,
      });
    });
};
